import {format, fromUnixTime} from "date-fns";

/**
 * Aplica un formato en el timestamp, devolviendo la hora como hh:mm aa
 * @param timestamp Timestamp (en segundos) que se desea formatear
 */
export function formatTimestampToTime(timestamp: number) {
    return format(fromUnixTime(timestamp), 'hh:mm aa')
}
